import React, { useEffect, useState } from "react";
import { PaginationShow } from "../../comman/action/Pagination";
import { useSearchParams } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import NotFound from "../../components/not-found/NotFound";
import { GiReceiveMoney } from "react-icons/gi";
import {
  DatePicker,
  Select,
  dateFormat,
  searchDateFormat,
} from "../../components/Form";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { SecondaryButton } from "../../components/Button/Button";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { getPaymentApi } from "../../services/payment";
import { catchMessage, elseMessage } from "../../comman/Message";
import { setJwtToken } from "../../config/axiosInstance";
import useButtonLoader from "../../hooks/UseButtonLoader";
import axios from "axios";
const date = dateFormat(new Date());
const PaymentManagement = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let userTypeSearch = searchParam.get("type") || "";
  let searchStartDate = searchParam.get("startDate") || "";
  let searchEndDate = searchParam.get("endDate") || "";
  const [buttonref, buttonLoader] = useButtonLoader("Export as CSV");
  const url = `${process.env.REACT_APP_API_URL}/admin/fund/export_billing`;
  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [payment, setPayment] = useState([]);
  const [orderByName, setOrderByName] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [direction, setDirection] = useState("");
  //------------handle-page---------------
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //---------search-start-date--------------
  const handleStartDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("startDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  //---------search-ebd-date--------------
  const handleEndDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("endDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  //------------search-type--------------
  const handleType = (event) => {
    searchParam.set("page", 1);
    searchParam.set("type", event.target.value);
    setSearchParam(searchParam);
  };
  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    setOrderByName("");
    setDirection("createdAt");
    setFieldName("ASC");
    searchParam.delete("startDate");
    searchParam.delete("endDate");
    searchParam.delete("type");
    setSearchParam(searchParam);
  };
  //--------------sorting-name------------------------
  const orderByNameFun = () => {
    const newDirection = orderByName === "ASC" ? "DESC" : "ASC";
    setOrderByName(newDirection);
    setFieldName("name");
    setDirection(newDirection);
  };
  //------------------listing-Api----------------------------------
  const fathPayment = async (
    page = activePage,
    search = debounceValue,
    sortField = fieldName,
    sortDirection = direction,
    userType = userTypeSearch,
    startDate = searchStartDate,
    endDate = searchEndDate
  ) => {
    try {
      setPayment([]);
      showLoader();
      const res = await getPaymentApi({
        page,
        search,
        sortField,
        sortDirection,
        userType,
        startDate,
        endDate,
      });
      if (res?.data?.status === 200) {
        // console.log("payment", res?.data?.data?.total)
        setPayment(res?.data?.data?.list || []);
        setTotal(res?.data?.data?.total || 0);
        hideLoader();
      } else {
        setPayment([]);
        setTotal(0);
        hideLoader();
        elseMessage(res);
      }
    } catch (e) {
      hideLoader();
      catchMessage(e);
    }
  };

  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    if (!userTypeSearch) {
      searchParam.delete("type");
    }

    setSearchParam(searchParam);
    fathPayment(
      activePage,
      debounceValue,
      fieldName,
      direction,
      userTypeSearch
    );
  }, [searchParam, debounceValue, userTypeSearch, fieldName, direction]);

  useEffect(() => {
    if (
      (searchStartDate && searchEndDate) ||
      (searchStartDate === "" && searchEndDate === "") ||
      (searchStartDate === null && searchEndDate === null)
    ) {
      // fathPayment(activePage, debounceValue, fieldName, direction, userTypeSearch, searchStartDate, searchEndDate)
    }
    if (!searchStartDate) {
      searchParam.delete("startDate");
    }
    if (!searchEndDate) {
      searchParam.delete("endDate");
    }
    setSearchParam(searchParam);
  }, [searchStartDate, searchEndDate]);

  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
  }, [search]);
  const downloadFile = async (url, fileName, params = {


  }) => {
    try {
      buttonLoader(true);
      const { headers } = setJwtToken();
      const response = await axios.get(url, {
        params,
        responseType: "blob",
        headers,
      });

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      buttonLoader(false);
    }
  };
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Bills & Payment</h4>
            <button
              className="btn_size"
              ref={buttonref}
              onClick={() => downloadFile(url,`Bill & Payment_${date}`)}
            >
              Export as CSV
            </button>
          </div>
          <div className="FilterBox FilterArea">
            <div className="form-group search">
              <input
                type="search"
                className="form-control"
                placeholder="Search"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="form-group select_width">
              <Select
                className={`form-control ${
                  userTypeSearch === "" ? "text-secondary" : "text-dark"
                }`}
                value={userTypeSearch}
                onChange={handleType}
              >
                <option value="">Select Type</option>
                <option value="subscription">Subscription</option>
                <option value="donation">Donation</option>
              </Select>
            </div>

            <div className="form-group date_picker">
              <DatePicker
                className="form-control "
                name="startDate"
                selected={searchStartDate}
                placeholder="Start Date"
                onChange={(date) => handleStartDate(date)}
                maxDate={searchEndDate}
              />
            </div>
            <div className="form-group date_picker">
              <DatePicker
                name="endDate"
                className="form-control"
                placeholder="End Date"
                selected={searchEndDate}
                onChange={(date) => handleEndDate(date)}
                minDate={searchStartDate}
              />
            </div>

            <div className="form-group refresh_button">
              <SecondaryButton onClick={refreshHandler}>
                <RotateLeftIcon />
              </SecondaryButton>
            </div>
          </div>

          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Transaction Id</th>
                  <th>Type</th>
                  <th>Payment by</th>
                  <th>Amount</th>
                  <th>
                    <div className="sorting-th" onClick={orderByNameFun}>
                      <span>Our earning</span>
                      {orderByName === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )}
                    </div>
                  </th>
                  <th>Transaction date</th>
                </tr>
              </thead>

              <tbody>
                {payment.length > 0 ? (
                  payment.map(
                    (
                      {
                        userId,
                        amount,
                        name,
                        paymentIntentId,
                        type,
                        status,
                        createdAt,
                        modifyAmount
                      },
                      index
                    ) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{++index + (activePage - 1) * 10}</td>
                            <td>{paymentIntentId || "N/A"}</td>
                            <td>{type || "N/A"}</td>
                            <td>{name || "N/A"}</td>
                            <td>{amount || "N/A"}</td>
                            <td>{modifyAmount ? Math.abs(modifyAmount).toFixed(2) : "N/A"}</td>
                            <td>{dateFormat(createdAt) || "N/A"}</td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={10}
                    msg="No Payment Found!"
                    icon={<GiReceiveMoney style={{ fontSize: 48 }} />}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <PaginationShow
            total={total}
            activePage={activePage}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};
export default PaymentManagement;
